import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("op_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const getToken = () => localStorage.getItem("op_token");
export const setToken = (t) => localStorage.setItem("op_token", t);
export const clearToken = () => localStorage.removeItem("op_token");

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return String(d);
}
